import React, { useEffect, useState } from "react";
import styles from "./ForgotPassword.module.css";

import { InputText } from "primereact/inputtext";
import { FloatLabel } from 'primereact/floatlabel';
import { Button } from "primereact/button";
import { useDispatch, useSelector } from "react-redux";
import { authActions } from "../../../store/auth-store/auth-slice";

import DataLabLogo from "../../../assets/img/DataLabLogo.png";
import { ForgotMyPassword, SignIn } from "../../../store/auth-store/auth-actions";
import Loading from "../../../components/UI/loading/Loading";


const ForgotPassword = () => {

  const auth = useSelector((state) => state.auth.auth);
  const dispatch = useDispatch();
  const [invalidField, setInvalidField] = useState("");
  const [filledInputs, setFilledInputs] = useState({
    name: false,
    lastName: false,
    email: false,
    password: false,
  });
  const [focused, setFocused] = useState({
    name: false,
    lastName: false,
    email: false,
    password: false,
  });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  },);

  const handleBlur = (field) => {
    setFocused((prev) => ({ ...prev, [field]: false }));
    setFilledInputs((prev) => ({ ...prev, [field]: prev[field] }));
  };

  const handleFocus = (field) => {
    setFocused((prev) => ({ ...prev, [field]: true }));
  };

  const onChangeHandler = (id, value) => {
    setInvalidField("");
    setFilledInputs((prev) => ({ ...prev, [id]: value.length > 0 }));
    dispatch(authActions.modifyPropertyValue({ id, value }));

    if (value !== "") {
      dispatch(authActions.setFieldValid({ id, value: true }));
    } else {
      dispatch(authActions.setFieldValid({ id, value: false }));
    }
  };

  const goToLogin = (e) => {
    window.location.href = "/";
  };

  const onSubmitHandler = () => {

    setInvalidField("");
    if (auth.email === "") {
      setInvalidField("email");
      return;
    }

    dispatch(ForgotMyPassword(auth.email));
    // window.location.href = "/";
  };

  if (isLoading) {
    return <Loading />;
  }

  return (
    <>
      {auth !== null && auth !== undefined && auth !== "" && (
        <div className={`${styles.registerContainer} flex justify-content-center align-items-center`}>
          <div className={`${styles.registerCard} surface-card px-6 py-6 shadow-2 grid grid-nogutter`}>
            <i onClick={() => goToLogin()} className={`pi pi-arrow-left ${styles.goBackIcon}`}></i>
            <div className={styles.registerFields}>
              <h2 className={`${styles.textCenter} text-2xl`}>Recuperar contraseña</h2>
              <div className="flex flex-column gap-3">

                <FloatLabel className={filledInputs.email || focused.email ? "mt-4" : "mt-0"}>
                  <InputText
                    id="email"
                    name="email"
                    type="text"
                    label="Correo Electrónico"
                    value={auth.email !== undefined ? auth.email : ""}
                    onFocus={() => handleFocus("email")}
                    onBlur={() => handleBlur("email")}
                    onChange={(e) => onChangeHandler("email", e.target.value)}
                    className={styles.InputFields}
                    invalid={invalidField === "email"}
                  />
                  <label className={styles.InputFields}>Correo Electrónico</label>
                </FloatLabel>
                {invalidField === "email" && (
                  <small id="email-help" className={`${styles.inputWarningText}`}>El campo correo electrónico no puede estar vacío</small>
                )}

                <Button onClick={() => onSubmitHandler()} label="Enviar" type="submit" className={`${styles.registerButton} p-button-primary mt-1`} />
              </div>
            </div>
          </div>
          <div className={styles.logoContainer}>
            <img src={DataLabLogo} alt="PrimeReact Logo" className={`${styles.logo} mb-4`} />
          </div>
        </div>
      )}
    </>
  );
};

export default ForgotPassword;
